module.exports = __webpack_public_path__ + "c624a59e667d2306c61298e85a40e3f3.png";